import { t } from "i18next";

import { Box } from "#shared/view/components/Box";
import { Image } from "#shared/view/components/Image";
import { Paper } from "#shared/view/components/Paper";
import { ProgressBar } from "#shared/view/components/ProgressBar";
import { Stack } from "#shared/view/components/Stack";
import { Text } from "#shared/view/components/Text";

const ILLUSTRATION_SIZE = 100;
const PROGRESS_BAR_HEIGHT = "25px";

function SearchSimilarPartDropzoneStatus({
  message,
  illustration,
  uploadProgress,
  progressBarColor,
}: {
  message: string;
  illustration: string;
  uploadProgress?: number;
  progressBarColor?: string;
}) {
  if (uploadProgress) {
    return (
      <Stack align={"center"} justify={"center"} w="350px">
        <Box w={ILLUSTRATION_SIZE} h={ILLUSTRATION_SIZE}>
          <Image src={illustration} w={ILLUSTRATION_SIZE} />
        </Box>

        <Paper h={PROGRESS_BAR_HEIGHT} w={"100%"} bg="red" p="0">
          <ProgressBar
            style={{ height: PROGRESS_BAR_HEIGHT }}
            value={uploadProgress}
            label={`${t("qr.dropzone.upload")} : ${uploadProgress} %`}
            animated={uploadProgress < 100}
            color={progressBarColor}
          />
        </Paper>
      </Stack>
    );
  }

  return (
    <Stack align={"center"} justify={"center"} w="350px">
      <Box w={ILLUSTRATION_SIZE} h={ILLUSTRATION_SIZE}>
        <Image src={illustration} w={ILLUSTRATION_SIZE} />
      </Box>

      <Text size="xl" inline fw={600} h={PROGRESS_BAR_HEIGHT}>
        {message}
      </Text>
    </Stack>
  );
}

export default SearchSimilarPartDropzoneStatus;
